import { useAtomValue, useSetAtom, useStore } from 'jotai';
import { basemapAtom, BasemapSync } from '@/features/basemap';
import { WindLayer } from '@/features/forecast';
import { computeConeAtom, GlideMapLayers, useOriginActionLabel } from '@/features/glide';
import { MapProvider, readUrlView, UrlViewSync } from '@/features/map';
import { SearchPlaceMarker } from '@/features/search';
import { StationLayer, stationsVisibilityAtom } from '@/features/stations';
import { TerrainControl } from '@/features/terrain';
import { trailsVisibilityAtom, TrailsSync } from '@/features/trails';
import { MapScale, unitsAtom } from '@/features/units';
import { appModeAtom } from './atoms';
import { ControlPanel } from './ControlPanel';
import { createMapStyle } from './mapStyle';

const DEFAULT_VIEW = { lat: 40.4399, lng: -111.7464, zoom: 12 };
const initialView = readUrlView(DEFAULT_VIEW);

export function App() {
  const store = useStore();
  const compute = useSetAtom(computeConeAtom);
  const originActionLabel = useOriginActionLabel();
  const exploring = useAtomValue(appModeAtom) === 'explore';

  return (
    <MapProvider
      initialView={initialView}
      createStyle={() =>
        createMapStyle(
          store.get(basemapAtom),
          store.get(unitsAtom),
          store.get(trailsVisibilityAtom) === 'on',
          store.get(stationsVisibilityAtom) === 'on',
        )
      }
    >
      <UrlViewSync />
      <MapScale />
      <TerrainControl />
      <BasemapSync />
      <TrailsSync />
      <WindLayer visible={!exploring} />
      <GlideMapLayers interactive={exploring} />
      <StationLayer />
      <SearchPlaceMarker
        action={exploring ? { label: originActionLabel, onAction: (item) => void compute(item) } : undefined}
      />
      <ControlPanel />
    </MapProvider>
  );
}
